var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"aki-btn",class:[("aki-btn-" + _vm.type), {'aki-btn-dense': _vm.size=='dense'}],style:({width:_vm.cwidth}),on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }